import type { JSX } from "solid-js";
import { DumpIcon } from "./DumpIcon";

type DumpDetailProps = {
  label: string;
  meta?: JSX.Element;
  onBack: () => void;
  actions?: JSX.Element;
  children: JSX.Element;
};

export function DumpDetail(props: DumpDetailProps) {
  return (
    <div class="flex h-full w-full flex-col gap-3">
      <div class="flex min-h-11 w-full items-center justify-between bg-[rgba(255,255,255,.08)] pl-4 pr-2">
        <div class="flex min-w-0 items-center gap-3">
          <p class="py-2 leading-none roboto500">{props.label}</p>
          {props.meta}
        </div>
        <div class="flex gap-2">
          <button
            class="flex h-7 w-7 rotate-[270deg] cursor-pointer items-center justify-center bg-blue-gradient transition-all duration-200 ease-in-out hover:drop-shadow-blue-gradient"
            aria-label="Go back"
            onClick={props.onBack}
          >
            <DumpIcon name="icon_arrow_up" />
          </button>
          {props.actions}
        </div>
      </div>
      <div class="flex h-[calc(100%-4.75rem)] flex-col overflow-y-auto bg-gray-gradient">
        {props.children}
      </div>
    </div>
  );
}

export function DumpField(props: {
  label: string;
  value: string | number;
  disabled?: boolean;
  type?: "text" | "number";
  onInput?: (value: string) => void;
}) {
  return (
    <li class="flex min-h-10 justify-between pl-4 leading-10">
      <p>{props.label}</p>
      <input
        autocomplete="off"
        class="w-[70%] bg-[rgba(255,255,255,.11)] px-3 text-left text-white disabled:cursor-not-allowed disabled:opacity-40"
        type={props.type ?? "text"}
        value={props.value}
        disabled={props.disabled}
        onInput={(event) => props.onInput?.(event.currentTarget.value)}
      />
    </li>
  );
}
